<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>费率管理</el-breadcrumb-item>
          <el-breadcrumb-item>费率列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addLinkUrl"
                v-if="flagAdd"
                >新增</el-button
              >
            </el-button-group>
          </div>
          <div class="r-list">
            <div class="option">
              <cn-select-search
                v-model="companyId"
                :v_disabled="disabled"
                :v_whole="true"
                :data="companyList"
                @val="setCompanyId"
                placeholder="请筛选客户..."
              >
              </cn-select-search>
            </div>
            <div class="search-box">
              <el-input placeholder="输入费率名称，关健字" v-model="keyword">
                <el-button
                  type="primary"
                  slot="append"
                  icon="el-icon-search"
                  @click="initData"
                ></el-button>
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyName }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column prop="feeName" label="费率名称"></el-table-column>
            <el-table-column prop="remark" label="费率说明"></el-table-column>

            <el-table-column
              prop="gmtModified"
              label="更新时间"
            ></el-table-column>
            <el-table-column
              prop="gmtCreate"
              label="添加时间"
            ></el-table-column>

            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-plus"
                  title="复制"
                  @click="linkUrl(scope.row.id, 1)"
                ></el-button>
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  title="编辑"
                  v-if="flagUpdate"
                  @click="linkUrl(scope.row.id, 2)"
                ></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  v-if="flagDel"
                  @click="deleteItem(scope.row.id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      companyId: "",
      disabled: false,
      companyList: [],
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      flagLook: false,
      flagDel: false,
      flagAdd: false,
      flagUpdate: false,
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "结算中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "费率管理");
        if (obj1.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj1.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj1.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj1.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }
        obj1.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
        });
      }
    },
    //初始化工具栏
    initLoad: function () {
      let _this = this;

      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.companyId = window.localStorage.getItem("fx_login_companyId");
        _this.disabled = true;
      }
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/feeConfig/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      if (_this.keyword.length > 0) {
        sendUrl += "&feeNameLike=" + encodeURI(_this.keyword);
      }

      if (_this.companyId.length > 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    addLinkUrl() {
      this.$router.push({ name: "FeeConfigEdit" });
    },
    //跳转链接
    linkUrl: function (url, type) {
      this.$router.push({ name: "FeeConfigEdit", query: { id: url, type } });
    },
    //单项删除
    deleteItem: function (val) {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //执行删除操作
      _parent
        .$confirm("确认要删除该记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "delete",
            url: "/cabinet/feeConfig/" + val,
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              _this.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
    },
  },
  created: function () {
    //加载数据
    this.initLoad();
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/FeeConfig/FeeConfigList.vue